<template>
    <div>
        <div class="animation d-flex" v-for="(title, index) in convertedTitle" :key="`title-${index}`">
            <span class="animation-block" :class="{'is-active': started}">
                <span class="animation-block-inner">
                    <span class="animation-block-text mb-1" v-html="title" :id="id"></span>
                </span>
            </span>
        </div>
        <intersection-observer sentinal-name="sentinal-name"
                               @on-intersection-element="onIntersectionElement"></intersection-observer>
    </div>
</template>

<script>
    import IntersectionObserver from "./IntersectionObserver";
    import TinySegmenter from 'tiny-segmenter'

    export default {
        name: "animation-sub-title",
        props: {
            className: String,
            id: String,
            title: String,
            center: Boolean,
        },
        components: {IntersectionObserver},
        data() {
            return {
                started: false,
                changedTitle: false,
            }
        },
        mounted() {
            this.changedTitle = true;
        },
        computed: {
            convertedTitle() {
                if(this.changedTitle) {
                    return this.getLines();
                }
                else {
                    return [this.splitLines(this.title)];
                }
            }
        },
        methods: {
            onIntersectionElement(value) {
                if(value && !this.started) {
                    this.started = true;
                }
            },
            splitLines(title) {
                var segmenter = new TinySegmenter();
                return title.split('<br/>').map(function(line) {
                    var segs = segmenter.segment(line);
                    let quote = false;
                    return segs.map(function (word) {
                        if(word == '“') {
                            quote = true;
                            return '';
                        } else if(word == ' “'){
                            quote = true;
                            return '<span>&nbsp;</span>';
                        } else if(word == '”'){
                            return '';
                        }

                        if(quote) {
                            quote = false;
                            return '<span>“' + word + '”</span>'
                        }
                        return '<span>' + (word == ' ' ? '&nbsp;' : word) + '</span>'
                    }).join('');
                }).join('<br/>');
            },
            getLines() {
                let lines = [];
                let line;
                let p = document.getElementById(this.id);
                let words = p.getElementsByTagName('span');
                let lastTop;
                for (var i = 0; i < words.length; i++) {
                    var word = words[i];
                    var rec = word.getBoundingClientRect();
                    if (rec.top != lastTop) {
                        lastTop = rec.top;
                        line = [];
                        lines.push(line);
                    }
                    line.push(word);
                }
                return lines.map(function (line) {
                    return line.map(function (span) {
                        return span.innerText;
                    }).join('')
                });
            }
        }
    };
</script>

<style lang="scss">
    .line {
        display: inline-block;
    }
    .animation-block-text {
        > span {
            display: inline-block;
        }
    }
</style>
<style lang="scss" scoped>
    .animation-block-inner {
        transform: translateZ(0);
        transform-origin: left center;
    }

    .animation-block, .animation-block-inner {
        position: relative;
        display: block;
        overflow: hidden;
    }

    .animation-block.is-active .animation-block-inner {
        &:after {
            transform: translateX(101%);
        }

        .animation-block-text {
            background-position: 0 100%;
        }
    }

    .animation-block-inner:after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: #000;
        transform-origin: right;
        transition: transform .5s cubic-bezier(0.075, 0.82, 0.165, 1) 0.2s;
        z-index: -1;
    }

    .animation-block-text {
        position: relative;
        background: linear-gradient(to right, #000, #000 50%, #FFF 50%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-size: 200% 100%;
        background-position: 100%;
        transition: background-position .5s cubic-bezier(0.075, 0.82, 0.165, 1) 0.2s;
    }

    @for $i from 2 through 10 {
        .animation {
            &:nth-child(#{$i}) {
                .animation-block-inner {
                    &::after {
                        transition: transform .5s cubic-bezier(0.075, 0.82, 0.165, 1) #{($i - 1) * .5 + .2}s;
                    }

                    .animation-block-text {
                        transition: background-position .5s cubic-bezier(0.075, 0.82, 0.165, 1) #{($i - 1) * .5 + .2}s;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 540px) {
        .animation-block-inner:after {
            transition: transform .25s cubic-bezier(0.075, 0.82, 0.165, 1) 0.2s;
        }

        .animation-block-text {
            transition: background-position .25s cubic-bezier(0.075, 0.82, 0.165, 1) 0.2s;
        }
        @for $i from 2 through 10 {
            .animation {
                &:nth-child(#{$i}) {
                    .animation-block-inner {
                        &::after {
                            transition: transform .25s cubic-bezier(0.075, 0.82, 0.165, 1) #{($i - 1) * .25 + .2}s;
                        }

                        .animation-block-text {
                            transition: background-position .25s cubic-bezier(0.075, 0.82, 0.165, 1) #{($i - 1) * .25 + .2}s;
                        }
                    }
                }
            }
        }
    }
</style>